import React from 'react';

export const StashDetailsModal = ({ stash, onClose }) => {
  if (!stash) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="glass-card p-6 rounded-xl shadow-lg w-full max-w-md animate-fadeIn custom-scrollbar" style={{maxHeight: '90vh', overflowY: 'auto'}}>
        <h3 className="text-2xl font-bold gradient-text mb-4 text-center">Stash Details</h3>
        <div className="space-y-3 text-gray-300">
          <p><strong>Name:</strong> {stash.name || 'N/A'}</p>
          <p><strong>Owner:</strong> {stash.owner || 'N/A'}</p>
          <p><strong>Location:</strong> X: {stash.location?.x?.toFixed(2) || 'N/A'}, Y: {stash.location?.y?.toFixed(2) || 'N/A'}, Z: {stash.location?.z?.toFixed(2) || 'N/A'}</p>
          
          {stash.items && Object.keys(stash.items).length > 0 && (
            <>
              <p className="font-semibold text-white mt-4">Items:</p>
              <ul className="list-disc list-inside ml-4">
                {Object.entries(stash.items).map(([itemName, itemDetails]) => (
                  <li key={itemName} className="mb-1">
                    <strong>{itemName}:</strong> Quantity: {itemDetails.count || 0}, Quality: {itemDetails.quality || 'N/A'}
                  </li>
                ))}
              </ul>
            </>
          )}
          {(!stash.items || Object.keys(stash.items).length === 0) && (
            <p className="text-gray-400 italic">No items in this stash.</p>
          )}
        </div>
        <button
          onClick={onClose}
          className="mt-6 bg-[#316dae] hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md transition duration-300 w-full"
        >
          Close
        </button>
      </div>
    </div>
  );
};